import axios from "axios";

export const devGetTempToken = (openid) => {
  return axios.get('/api/wechat/oauth/callback?openid=' + openid).then(response => {
    Log('response', response);
    const data = response.data || {};
    if (data.code === 0) {
      return data.data;
    }
  })
}



// WEBPACK FOOTER //
// ./src/utils/devGetTempToken.js